// extracted by css-extract-rspack-plugin
export default {"NavBarWrapper":"GivingCampaignGroupRow_NavBarWrapper__hQKLv"};